export default "/images/pr-img-1.png?fc0c27967f674639fc3dfbc806048ee2";